import consumer from "./consumer"

consumer.subscriptions.create("NotificationsChannel", {
  received({type, body}) {
    const event = new CustomEvent(type, {detail: body})
    document.dispatchEvent(event)
  }
})